import { useState } from 'react';
import { siteBrand } from '@/mocks/home';

const navLinks = [
  { label: '正在开播', href: '#live' },
  { label: '专题合集', href: '#collections' },
  { label: '人气榜单', href: '#ranking' },
  { label: '精彩短视频', href: '#shorts' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              {siteBrand.name}
            </span>
            <span className="mt-0.5 hidden text-[11px] tracking-wide text-foreground-500 sm:block">
              {siteBrand.tagline}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#live"
            className="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 sm:flex"
            aria-label="搜索主播"
          >
            <i className="ri-search-line text-lg" />
          </a>
          <a
            href="#faq"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            下载糖豆视频
          </a>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1280px] flex-col px-4 py-3 md:px-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              下载糖豆视频
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}